import * as React from 'react'

import { Box, Icon, Popover, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

import getTagDescription from './getTagDescription'

const BankOfHoursButton = ({ onClick }: { onClick: () => void }) => {
  const [hover, setHover] = React.useState<boolean>(false)

  const { bankOfHours, openPeriod, lastCycle, loading, featureByName } = useTimesheetData()
  const hasBankOfHours = TimesheetFeatures.BANK_OF_HOURS in featureByName

  const displayBankOfHours = hasBankOfHours && !loading

  const tagDescription = getTagDescription({ openPeriod, lastCycle })

  return displayBankOfHours ? (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      paddingX="s8"
      flexDirection="row"
      alignItems="center"
      gap="s4"
      onClick={onClick}
    >
      {!openPeriod ? (
        <Box paddingY="s4" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          <Popover.ItemList
            gapDivider={false}
            attachment="top center"
            open={hover}
            toggle={() => () => undefined}
          >
            <Icon.Small icon="alert-circle" color="champagne1000" />

            <Text color="grey000White" weight="medium" size="200">
              {tagDescription}
            </Text>
          </Popover.ItemList>
        </Box>
      ) : (
        <Box paddingY="s4" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          <Popover.ItemList
            gapDivider={false}
            attachment="top center"
            open={hover}
            toggle={() => () => undefined}
          >
            <Icon.Small icon="clock" color="grey600" />
            <Text color="grey000White" weight="medium" size="200">
              {tagDescription}
            </Text>
          </Popover.ItemList>
        </Box>
      )}
      <Text size="200" weight="medium">
        {i18n.t('clock_in.bank_of_hours.button.label')}
      </Text>

      <Tag type={Tag.Types.grey3} size="small">
        <MinutesToText value={bankOfHours} size="100" weight="medium" />
      </Tag>
    </Box>
  ) : (
    <Box />
  )
}
export default BankOfHoursButton
